<template>
    <v-card :loading="loading" class="pb-6">
        <v-card-title class="text-h5">
            <v-btn
                small
                icon
                @click="close"
                color="primary"
                class="ml-n3 mr-2 my-2 py-0"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            Packing Balance <v-spacer />
        </v-card-title>
        <v-divider class="ml-4 mr-5 mb-2" />
        <v-card-text class="pb-0">
            <p>
                The following work orders have quantities pending to be packed.
                Select the work orders to create a new packing list of type
                “Domestic Shipping”.
            </p>
            <v-data-table
                id="virtual-scroll-table"
                disable-pagination
                hide-default-footer
                :headers="headers"
                :items="Object.values(workOrders)"
                class="elevation-0"
                :mobile-breakpoint="0"
                fixed-header
                :height="$vuetify.breakpoint.mdAndDown ? '50vh' : '50vh'"
                :loading="loading"
                multiple-expand
                :expanded.sync="expanded"
                show-expand
            >
                <template v-slot:top>
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pb-0 align-center"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <v-col cols="12">
                            <h2 class="ml-4">
                                Work Orders
                            </h2>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.workOrder`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.code }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.packableQty`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.packableQty }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.packedQty`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.packedQty || 0 }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.balance`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.balance || 0 }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.selected`]="{ item }">
                    <div class="d-flex justify-center">
                        <v-simple-checkbox
                            color="primary"
                            v-model="item.selected"
                            :disabled="loading || item.balance <= 0"
                        ></v-simple-checkbox>
                    </div>
                </template>
                <template
                    v-slot:expanded-item="{
                        headers,
                        item: item,
                    }"
                >
                    <td
                        :colspan="headers.length"
                        class="pa-4 ma-0 outlined"
                        :style="{ background: 'white' }"
                    >
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="subheaders"
                                    :items="item.partNumbers"
                                    class="elevation-0"
                                    :mobile-breakpoint="0"
                                    :loading="loading"
                                    disable-pagination
                                    hide-default-footer
                                >
                                    <template v-slot:top>
                                        <v-row
                                            no-gutter
                                            class="mt-0 mx-0 pb-0 align-center"
                                            :style="{
                                                'background-color': '#eeeeee',
                                            }"
                                        >
                                            <v-col cols="12">
                                                <h2 class="ml-4">
                                                    Part Numbers
                                                </h2>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <!--ITEMS-->
                                    <template
                                        v-slot:[`item.partNumber`]="{ item }"
                                    >
                                        <div class="d-flex justify-center">
                                            <p class="my-0 text-capitalize">
                                                {{ item.partNumber }}
                                            </p>
                                        </div>
                                    </template>
                                    <template
                                        v-slot:[`item.suggestedQty`]="{ item }"
                                    >
                                        <div class="d-flex justify-center">
                                            <p class="my-0 text-capitalize">
                                                {{ item.suggestedQty || 0 }}
                                            </p>
                                        </div>
                                    </template>
                                    <template
                                        v-slot:[`item.packingQty`]="{ item }"
                                    >
                                        <div class="d-flex justify-center">
                                            <p class="my-0 text-capitalize">
                                                {{ item.packingQty || 0 }}
                                            </p>
                                        </div>
                                    </template>
                                    <template
                                        v-slot:[`item.balance`]="{ item }"
                                    >
                                        <div class="d-flex justify-center">
                                            <p class="my-0 text-capitalize">
                                                {{ item.balance || 0 }}
                                            </p>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions ref="actions">
            <v-spacer />
            <v-btn
                color="primary"
                rounded
                class="mt-2 mr-3 white--text"
                :loading="loading"
                @click="markAsScheduled"
            >
                {{
                    `MARK AS SCHEDULED ${
                        Object.values(workOrders).filter(wo => wo.selected)
                            .length > 0
                            ? 'AND CREATE A NEW PACKING LIST'
                            : ''
                    }`
                }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'BalanceWarning',
    props: {
        packingList: {
            type: Object,
            required: true,
        },
        packingItems: {
            type: Array,
            required: true,
        },
        projectPackingLists: {
            type: Array,

            default: () => [],
        },
        projectWorkOrders: {
            type: Array,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        expanded: [],
        headers: [
            {
                text: 'WORK ORDER',
                value: 'workOrder',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SUGGESTED QTY',
                value: 'suggestedQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PACKED QTY',
                value: 'packedQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'BALANCE',
                value: 'balance',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SELECTED',
                value: 'selected',
                align: 'center',
                sortable: false,
            },
        ],
        subheaders: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SUGGESTED QTY',
                value: 'suggestedQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PACKED QTY',
                value: 'packingQty',
                align: 'center',
                sortable: false,
            },
            {
                text: 'BALANCE',
                value: 'balance',
                align: 'center',
                sortable: false,
            },
        ],
        workOrders: {},
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
    }),
    async mounted() {
        try {
            if (
                this.packingList.selectedWorkOrders &&
                this.packingList.selectedWorkOrders.length > 0
            ) {
                this.buildBalanceData()
            }

            if (Object.values(this.workOrders).length == 0) {
                this.markAsScheduled()
            }
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,

                message: error.message,
            })
        }
    },

    methods: {
        ...mapMutations(['setErrorItems']),

        parseJsonArray(raw) {
            if (raw == null || raw === '') return []

            try {
                const v = typeof raw === 'string' ? JSON.parse(raw) : raw

                return Array.isArray(v) ? v : []
            } catch {
                return []
            }
        },

        getPartNumberMetadata(workOrderCode, partNumberKey) {
            return this.packingItems.find(
                item =>
                    item.workOrder == workOrderCode &&
                    item.partNumber == partNumberKey
            )
        },

        buildBalanceData() {
            const rejectableStatuses = ['inProgress', 'rejected', 'pending']

            const targetPartNumbers = {}

            if (this.packingList.packages?.length > 0) {
                this.packingList.packages.forEach(pkg => {
                    pkg.items?.forEach(item => {
                        if (!item.workOrder || !item.partNumber) return

                        const key = `${item.workOrder}:${item.partNumber}`

                        if (targetPartNumbers[key]) return

                        const found = this.getPartNumberMetadata(
                            item.workOrder,

                            item.partNumber
                        )

                        if (!found) return

                        targetPartNumbers[key] = {
                            partNumberId: found.partNumberId,
                            partNumber: found.partNumber,
                            costPosition: found.costPosition || '',
                            description: found.description || '',
                            finishAndUCCode: found.finishAndUCCode || '',
                            mass: found.mass || 0,
                            notes: found.notes || '',
                            oc: found.oc || '',
                            quantity: +found.quantity || 0,
                            workOrder: found.workOrder,
                            totalSuggested: 0,
                            totalPacked: 0,
                            targetQuantity: 0,
                        }
                    })
                })
            }

            const targetWorkOrderCodes = [
                ...new Set(
                    Object.values(targetPartNumbers).map(part => part.workOrder)
                ),
            ]

            const filteredPackingLists = this.projectPackingLists.filter(pl => {
                if (pl.operation == 'DELETE' && pl.status != 'completed') {
                    return false
                }

                const packages = this.parseJsonArray(pl.packages)

                const selectedWorkOrdersInPL = this.parseJsonArray(
                    pl.selectedWorkOrders
                )

                if (packages.length === 0) return false

                if (selectedWorkOrdersInPL.length === 0) return false

                return selectedWorkOrdersInPL.some(workOrder => {
                    const code = workOrder?.code

                    return code && targetWorkOrderCodes.includes(code)
                })
            })

            filteredPackingLists.forEach(pl => {
                const packages = this.parseJsonArray(pl.packages)

                packages.forEach(pkg => {
                    pkg.items?.forEach(item => {
                        if (!item.workOrder || !item.partNumber) return

                        const key = `${item.workOrder}:${item.partNumber}`

                        const partData = targetPartNumbers[key]

                        if (!partData) return

                        if (pl.id != this.packingList.id) {
                            if (!rejectableStatuses.includes(pl.status)) {
                                partData.targetQuantity += +item.packingQty || 0
                            } else {
                                partData.targetQuantity +=
                                    Math.max(
                                        +item.suggestedQty || 0,

                                        +item.packingQty || 0
                                    ) || 0
                            }
                        } else {
                            partData.totalPacked += +item.packingQty || 0

                            partData.totalSuggested += +item.suggestedQty || 0

                            partData.targetQuantity += +item.packingQty || 0
                        }
                    })
                })
            })

            Object.values(targetPartNumbers).forEach(partData => {
                const itemQty = partData.quantity ?? 0
                const targetQty = partData.targetQuantity ?? 0
                const totalPacked = partData.totalPacked ?? 0
                const totalSuggested = partData.totalSuggested ?? 0
                const maxSuggestableQty = itemQty - targetQty
                let balance
                let displaySuggestedQty

                if (totalSuggested === 0) {
                    displaySuggestedQty = itemQty

                    balance = Math.max(0, maxSuggestableQty)
                } else {
                    displaySuggestedQty = totalSuggested
                    const totalSuggestedNotPacked = totalSuggested - totalPacked
                    balance = Math.max(
                        0,

                        Math.min(
                            maxSuggestableQty,

                            totalSuggestedNotPacked
                        )
                    )
                }

                if (balance <= 0) return

                const partNumberElement = {
                    partNumberId: partData.partNumberId,
                    partNumber: partData.partNumber,
                    costPosition: partData.costPosition,
                    description: partData.description,
                    finishAndUCCode: partData.finishAndUCCode,
                    mass: partData.mass,
                    notes: partData.notes,
                    oc: partData.oc,
                    quantity: partData.quantity,
                    workOrder: partData.workOrder,
                    packingQty: totalPacked,
                    suggestedQty: displaySuggestedQty,
                    balance,
                }

                if (!this.workOrders[partData.workOrder]) {
                    this.$set(this.workOrders, partData.workOrder, {
                        id: partData.workOrder,
                        code: partData.workOrder,
                        packableQty: 0,
                        packedQty: 0,
                        suggestedQty: 0,
                        balance: 0,
                        partNumbers: [],
                        selected: true,
                    })
                }

                const workOrder = this.workOrders[partData.workOrder]
                workOrder.packedQty += totalPacked
                workOrder.suggestedQty += displaySuggestedQty
                workOrder.balance += balance
                workOrder.partNumbers.push(partNumberElement)
            })
        },

        close() {
            this.$emit('closeDialog')
        },

        markAsScheduled() {
            let selectedWorkOrders = Object.values(this.workOrders).filter(
                wo => wo.selected
            )

            selectedWorkOrders = selectedWorkOrders.map(wo => {
                return {
                    code: wo.code,

                    partNumbers: wo.partNumbers,
                }
            })

            this.$emit('markPLAsScheduled', selectedWorkOrders)

            this.close()
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;

    overflow: auto;
}

.v-data-table {
    border: 1px solid #eeeeee;
}
</style>
